var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 69,
    viewBox: "0 0 72 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4071 27.8407L36 10.2698L28.5929 27.8808L9.67699 29.5256L24.0531 42.1221L19.7522 60.6959L36 50.8273L52.2876 60.6959L47.9469 42.1221L62.323 29.5256L43.4071 27.8407ZM58.2611 69L36 55.5209L13.7788 69L19.5929 43.5262L0 26.3564L25.8451 24.0698L36 0L46.1549 24.0698L72 26.3564L52.4071 43.486L58.2611 69Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon4);
export default __webpack_public_path__ + "static/media/service_icon-4.b80dfcfa3c67f97c83b8aad3487fc3d2.svg";
export { ForwardRef as ReactComponent };